import React from 'react';
import { Reveal } from './Section';
type Stat = {
  value: string;
  icon: string;
  label: string;
};
const stats: Stat[] = [{
  value: '+500',
  icon: '👥',
  label: 'Inversores confían'
}, {
  value: '6+6',
  icon: '📚',
  label: 'Tomos + bonos'
}, {
  value: '4.9/5',
  icon: '⭐',
  label: 'Calificación'
}, {
  value: '🇦🇷',
  icon: '',
  label: 'Todo el país'
}];
export function StatsBar() {
  return <section aria-label="Estadísticas de Capital Consciente" className="w-full border-b border-white/5 bg-ink-950 px-5 py-8 sm:py-10" data-id="element-216" data-mp="1edr4346lpm2s">
      <Reveal data-id="element-217" data-mp="19l7m7v0vs4s6">
        <div className="mx-auto grid w-full max-w-4xl grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-218" data-mp="19ko5uiqvpog9">
          {stats.map(stat => <div key={stat.label} className="rounded-xl border border-brand/30 bg-black px-4 py-5 text-center sm:px-5" data-id="element-219" data-mp="10mciqqp818sk">
              <p className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-220" data-mp="vou5wp8329fa">
                {stat.value}
              </p>
              <p className="mt-2 text-[10px] font-semibold uppercase tracking-wide text-amber-400 sm:text-xs" data-id="element-221" data-mp="3onu8ur217pd9">
                {stat.icon && <span aria-hidden="true" data-id="element-222" data-mp="3tgdgz8hy9sao">{stat.icon} </span>}
                {stat.label}
              </p>
            </div>)}
        </div>
      </Reveal>
    </section>;
}